import { render, staticRenderFns } from "./dataRequest.vue?vue&type=template&id=d4ebd8e8&scoped=true"
import script from "./dataRequest.vue?vue&type=script&lang=js"
export * from "./dataRequest.vue?vue&type=script&lang=js"
import style0 from "./dataRequest.vue?vue&type=style&index=0&id=d4ebd8e8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4ebd8e8",
  null
  
)

export default component.exports